module.exports = __webpack_public_path__ + "img/product_21.08c0b6d.svg";